import { createActions, createReducer } from 'reduxsauce'

import EmpenhosLicitacaoService from '../../servicos/EmpenhosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEmpenhosLicitacaoInicio: [],
    buscaEmpenhosLicitacaoSucesso: ['empenhosLicitacao'],
    buscaEmpenhosLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEmpenhosLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEmpenhosLicitacaoInicio())
        let serv = new EmpenhosLicitacaoService()
        return serv
            .consultarPorLicitacao(filtro)
            .then(response => dispatch(Creators.buscaEmpenhosLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEmpenhosLicitacaoErro(error)))
    }
}

const buscaEmpenhosLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaEmpenhosLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEmpenhosLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.empenhosLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EMPENHOS_LICITACAO_INICIO]: buscaEmpenhosLicitacaoInicio,
    [Types.BUSCA_EMPENHOS_LICITACAO_ERRO]: buscaEmpenhosLicitacaoErro,
    [Types.BUSCA_EMPENHOS_LICITACAO_SUCESSO]: buscaEmpenhosLicitacaoSucesso,
})
